import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AccessControlService } from './access-control.service';
import { AlertNotificationService } from './alert-notification.service';
import { AccessAction, AccessKey, FeatureActionKey } from '../layouts/main-layout/components/sidebar/config/access-control.config';

export const aclGuard: CanActivateChildFn = (childRoute, _state) => {
  const accessKey = childRoute.data['accessKey'] as AccessKey | undefined;
  const featureActionKey = childRoute.data['featureActionKey'] as FeatureActionKey | undefined;
  const featureAction = (childRoute.data['featureAction'] as AccessAction | undefined) ?? 'modify';

  if (!accessKey) return true;

  const user = (() => {
    try { return JSON.parse(localStorage.getItem('user') ?? 'null'); }
    catch { return null; }
  })();

  const allowSelfAccess = childRoute.data['allowSelfAccess'] === true;
  if (allowSelfAccess && user?.userId != null && String(user.userId) === childRoute.paramMap.get('userId')) {
    return true;
  }

  let profileCode: string | null = null;
  if (user?.userProfiles?.length) {
    const savedProfileId = localStorage.getItem('selectedProfileId');
    const lowestIdProfile = user.userProfiles.reduce((prev: any, curr: any) =>
      prev.userProfileId < curr.userProfileId ? prev : curr);
    const found: any = savedProfileId
      ? (user.userProfiles.find((p: any) => String(p.userProfileId) === savedProfileId) ?? lowestIdProfile)
      : lowestIdProfile;
    profileCode = found?.profile ?? null;
  }

  const accessControlService = inject(AccessControlService);

  const hasSectionAccess = accessControlService.hasAccess(profileCode, accessKey);
  const hasActionAccess = !featureActionKey
    || accessControlService.hasFeatureActionAccess(profileCode, featureActionKey, featureAction);

  if (hasSectionAccess && hasActionAccess) {
    return true;
  }

  const router = inject(Router);
  const alertService = inject(AlertNotificationService);

  alertService.error('Access denied: you do not have permission to access this section.');

  const previousNav = router.getCurrentNavigation()?.previousNavigation;
  return previousNav?.finalUrl ?? router.createUrlTree(['/app']);
};
